import { Link } from 'react-router-dom';

interface CategoryCardProps {
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export default function CategoryCard({ name, slug, icon, description, count }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer text-center"
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-3">
        <i className={`${icon} text-xl`}></i>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 mb-1 font-heading whitespace-nowrap">
        {name}
      </h3>
      <p className="text-xs text-foreground-500 line-clamp-2 mb-2 leading-relaxed">
        {description}
      </p>
      <span className="text-xs text-primary-500 font-medium">
        {count} 个视频
      </span>
    </Link>
  );
}